export const isNullish: (value: unknown) => boolean = (value: unknown) =>
  value === undefined || value === null

export const isNotNullish: (value: unknown) => boolean = (value: unknown) => !isNullish(value)
